import { useEffect, useState, useContext, useRef } from "react";
import styles from "./NavigationBar.module.css";
import DataContext from "../../store/data-context";
import exitIcon from "../../../assets/icons/exit.svg";
import backIcon from "../../../assets/icons/back.svg";
import helpIcon from "../../../assets/icons/help.png";
import Help from "./Help";
import Contact from "./Contact";
import phoneIcon from "../../../assets/icons/phone.png";
import logo from "../../../assets/logo.png";
import AddHouseNumberModal from "../../UI/AddHouseNumberModal";

export default function HelperContainer({
    processIndex,
    setProcessIndex,
    closeApp,
}) {
    const [submit, setSubmit] = useState(".");
    const [back, setBack] = useState();
    const [moreInfo, setMoreInfo] = useState();
    const [onContact, setOnContact] = useState(false);
    const [houseNumberModal, setHouseNumberModal] = useState(false);

    const contactRef = useRef(null);
    const helpRef = useRef(null);
    const backFunctionRef = useRef(null);

    const processIndexRef = useRef(null);

    const {
        location: selectedLocation,
        setLocation: setSelectedLocation,
        checkAvailability,
        setFormSubmitted,
        setError,
        setLoading,
        formSent,
        inHelp,
        setInHelp,
        setSelectedAttributes,
        selectedAttributes,
        serviceType,
        setServiceType,
        isSatellite,
        setTriggerInputHouseNumber,
    } = useContext(DataContext);

    const inHelpRef = useRef(inHelp);

    useEffect(() => {
        inHelpRef.current = inHelp;
    }, [inHelp]);

    const goBack = (index) => {
        setProcessIndex(index);
    };

    const goToFinalForm = () => {
        setProcessIndex("order_form");
    };

    const moreOptions = () => {
        setProcessIndex("additional_options");
    };

    const submitMoreOptions = () => {
        setProcessIndex("order_form");
    };

    const checkServiceAvailability = async () => {
        if (selectedLocation) {
            setLoading(true);
            const result = await checkAvailability(selectedLocation.position);
            setLoading(false);
            if (result) {
                if (result.length === 0) {
                    setError({
                        message:
                            "Trenutno nema dostupnih usluga za odabranu lokaciju.",
                        action: "Pokušajte drugu lokaciju",
                    });
                } else {
                    setProcessIndex("service_selection");
                }
            }
        }
    };

    useEffect(() => {
        backFunctionRef.current = back && back.function;
    }, [back]);

    useEffect(() => {
        processIndexRef.current = processIndex;
    }, [processIndex]);

    useEffect(() => {
        if (inHelp.active === false) {
            switch (processIndex) {
                case "availability_check":
                    setSubmit({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            checkServiceAvailability();
                        },
                        value: "Provjeri Dostupnost",
                    });
                    setBack();
                    setMoreInfo();
                    return;
                case "service_selection":
                    setSubmit({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            goToFinalForm();
                        },
                        value: "Kontaktirajte nas",
                    });
                    setBack({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            goBack("availability_check");
                        },
                        value: "Natrag",
                    });
                    setMoreInfo({
                        function: moreOptions,
                        value: "Pomoć",
                    });
                    return;
                case "selected_service":
                    setSubmit({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            goToFinalForm();
                        },
                        value: "Pošalji upit",
                    });
                    setBack({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            goBack("service_selection");
                        },
                        value: "Natrag",
                    });
                    setMoreInfo();
                    return;
                case "order_form":
                    setSubmit({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            setLoading(true);
                            setFormSubmitted(true);
                        },
                        value: "Pošalji upit",
                    });
                    setBack({
                        function: () => {
                            setInHelp((prevValue) => ({
                                ...prevValue,
                                active: false,
                                quickTip: false,
                            }));
                            goBack("service_selection");
                        },
                        value: "Natrag",
                    });
                    setMoreInfo();
                    return;
                default:
                    setSubmit();
                    setBack();
                    setMoreInfo();
                    return;
            }
        }
    }, [processIndex, selectedLocation, inHelp]);

    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        const handleBackButton = (event) => {
            event.preventDefault();

            if (processIndexRef.current !== "availability_check") {
                backFunctionRef.current && backFunctionRef.current();
            } else {
                var prevPage = window.location.href;

                window.history.back();

                setTimeout(function () {
                    if (window.location.href == prevPage) {
                        window.location.href = "https://www.gtnet.hr/";
                    }
                }, 500);
            }
        };

        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [processIndex]);

    return (
        <>
            {houseNumberModal && (
                <AddHouseNumberModal
                    onClose={() => {
                        setHouseNumberModal(false);
                        setTriggerInputHouseNumber(true);
                    }}
                    onSubmit={() => {
                        setHouseNumberModal(false);
                        submit.function();
                    }}
                />
            )}
            <div className={`${styles[`mobile-actions`]} `}>
                <img
                    src={exitIcon}
                    className={`${styles[`mobile-icon`]} ${
                        styles[`invisible-exit`]
                    }`}
                    onClick={closeApp}
                />

                {processIndex === "availability_check" && (
                    <img
                        src={logo}
                        className={`${styles[`mobile-icon`]} ${
                            styles[`logo`]
                        } ${
                            processIndex !== "availability_check" &&
                            styles[`mobile-icon-invisible`]
                        } ${isSatellite && styles[`inverted-logo`]}`}
                        onClick={closeApp}
                    />
                )}

                <img
                    src={backIcon}
                    className={`${styles[`mobile-icon`]} ${
                        processIndex === "availability_check" &&
                        styles[`mobile-icon-invisible`]
                    }`}
                    onClick={back && back.function}
                />
            </div>

            <div
                className={`${styles.container} ${
                    formSent && styles[`smooth-exit`]
                }`}
            >
                {/* CONTACT */}
                <img
                    src={phoneIcon}
                    className={`${styles[`mobile-help`]} ${
                        styles[`contact-icon`]
                    }`}
                    onClick={() => setOnContact((prevValue) => !prevValue)}
                />

                <Contact
                    ref={contactRef}
                    onClose={() => {
                        setOnContact(false);
                    }}
                    onContact={onContact}
                />

                {/* CONTACT */}

                <Help
                    ref={helpRef}
                    onClose={() => {
                        setInHelp((prevValue) => ({
                            ...prevValue,
                            active: false,
                            quickTip: false,
                        }));
                    }}
                    setSubmit={setSubmit}
                    goToFinalForm={goToFinalForm}
                    inHelp={inHelp}
                    selectedAttributes={selectedAttributes}
                    setInHelp={setInHelp}
                    setSelectedAttributes={setSelectedAttributes}
                    description={inHelp.description}
                    title={inHelp.title}
                    serviceTypes={serviceType}
                    setServiceTypes={setServiceType}
                />

                <div className={`${styles[`button-container`]}`}>
                    <img
                        src={helpIcon}
                        className={`${styles[`mobile-help`]} `}
                        onClick={() =>
                            setInHelp((prevValue) => ({
                                ...inHelp,
                                active: !prevValue.active,
                            }))
                        }
                    />
                    <button
                        onClick={() => {
                            if (processIndex === "availability_check") {
                                if (
                                    selectedLocation &&
                                    selectedLocation.resultType ===
                                        "houseNumber"
                                ) {
                                    submit && submit.function();
                                } else {
                                    setHouseNumberModal(true);
                                }
                            } else {
                                submit && submit.function();
                            }
                        }}
                        className={`${styles[`button`]} ${
                            (!submit || !selectedLocation) &&
                            styles[`button-inactive`]
                        } ${!selectedLocation && styles[`button-disabled`]} ${
                            (inHelp.active || onContact) &&
                            processIndex !== "availability-check" &&
                            styles[`submit-in-help`]
                        }`}
                    >
                        {submit && submit.value}
                    </button>
                </div>
            </div>
        </>
    );
}
